import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import ContentWrapper from '../ContentWrapper';
import FormCard from '../FormCard';
import BasicInfo from './components/BasicInfo';
import { useBasicInfo } from 'hooks/newUniprofile/useBasicInfo';
import { Spin } from 'antd';

interface BasicInfoStepProps {
    isReview?: boolean;
}

const BasicInfoStep = forwardRef(({ isReview = false }: BasicInfoStepProps, ref) => {
    const [basicInfo, loading, refetch] = useBasicInfo();
    const formRef = useRef<any>();

    const onSubmit = async () => {
        try {
            if (formRef.current) {
                await formRef.current.onSubmit();
            }
        } catch (error) {
            console.error('Form save failed:', error);
            throw error;
        }
    };

    useImperativeHandle(ref, () => ({
        onSubmit,
    }));

    return (
        <Spin spinning={loading}>
            <ContentWrapper title="Basic information" description="Add your basic info to create your Uniprofile." showInfo={!isReview}>
                <FormCard
                    title="Basic information"
                    showHeader={isReview}
                    type={isReview ? 'review' : 'edit'}
                    onSave={onSubmit}
                    ref={formRef}
                >
                    {(isEditing) => <BasicInfo isEditing={isEditing} initValue={basicInfo} refetch={refetch} />}
                </FormCard>
            </ContentWrapper>
        </Spin>
    );
});

export default BasicInfoStep;
